import { Box, Image, Text, Spinner } from "@chakra-ui/react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  BASE_URL_MEDIA,
  BASE_URL_WISHLIST,
} from "../../../../Redux/App/action";
import { getAllCategory } from "../../../../Redux/ProductController/action";

const Loader = () => {
  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      width="100%"
      height="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      background="rgba(0, 0, 0, 0.5)"
      zIndex="9999"
    >
      <Spinner
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.200"
        color="blue.500"
        size="xl"
      />
    </Box>
  );
};

const GreetingsSubCat = () => {
  const [catData, setCatData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [catId, setCatId] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { allCat } = useSelector((store) => store.prodReducer);
  useEffect(() => {
    dispatch(getAllCategory());
  }, []);

  useEffect(() => {
    if (allCat && allCat.length > 0) {
      // Find the category with categoryName "GREETINGS" in allCat
      const greetingsCategory = allCat.find(
        (category) => category.categoryName === "GREETINGS",
      );

      if (greetingsCategory) {
        setCatId(greetingsCategory.categoryId);
        getCategoryData(greetingsCategory.categoryId);
      }
    }
  }, [allCat]);

  const getCategoryData = async (catId) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${BASE_URL_MEDIA}/config/subcategories/bycategoryid?categoryId=${catId}`,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data",
            Token: 123456,
          },
        },
      );
      if (response.status === 200) {
        setCatData(response.data);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  if (loading) {
    return (
      <Box h={"80vh"}>
        <Loader />
      </Box>
    );
  }

  return (
    <Box>
      <Box>
        <Box w={"100%"}></Box>
        <Text
          fontSize={{ base: "18px", md: "28px" }}
          fontWeight="bold"
          css={{
            backgroundImage: "linear-gradient(to left, #553c9a, #b393d3)",
            color: "transparent",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
          }}
          className="oswald-font"
        >
          Choose a card category to explore
        </Text>

        <Box
          w={"100%"}
          m={"auto"}
          display={"grid"}
          gridTemplateColumns={{
            md: "repeat(5,1fr)",
            base: "repeat(1,1fr)",
          }}
          gap={2}
          justifyContent={"center"}
          mb={10}
        >
          {catData &&
            catData.map((el, i) => (
              <Box>
                <Box
                  onClick={() => navigate(`/allgreetings/${el.subCategoryId}`)}
                  cursor="pointer"
                  margin="auto"
                  mt={10}
                  position="relative" // Add this for relative positioning
                  _hover={{
                    // Define styles for hover state
                    "&::before": {
                      content: "''",
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)", // Center the overlay
                      width: "95%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                      backdropFilter: "blur(3px)",
                      opacity: 1,
                      transition: "opacity 0.3s",
                    },
                    "& .hover-text": {
                      position: "absolute",
                      top: "50%", // Center vertically
                      left: "50%", // Center horizontally
                      transform: "translate(-50%, -50%)", // Center the text
                      color: "white",
                      opacity: 1,
                      transition: "opacity 0.3s",
                    },
                  }}
                >
                  <Image
                    margin="auto"
                    src={el.imageUrl}
                    key={i}
                    w="95%"
                    cursor="pointer"
                  />
                  <Text
                    className={"hover-text"}
                    position="absolute"
                    top="50%"
                    left="50%"
                    transform="translate(-50%, -50%)"
                    color="white"
                    opacity={0}
                    pointerEvents="none"
                    fontSize={{
                      base: "14px",
                      md: "10px",
                      lg: "14px",
                      xl: "16px",
                    }}
                    fontWeight={"semibold"}
                  >
                    Click to view more
                  </Text>
                </Box>
                <Text
                  fontSize={{
                    base: "14px",
                    md: "10px",
                    lg: "14px",
                    xl: "16px",
                  }}
                  className="lato-font"
                >
                  {el.subCategoryName} Cards
                </Text>
              </Box>
            ))}
        </Box>
      </Box>
    </Box>
  );
};

export default GreetingsSubCat;
